import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ControlledSwitches from "./ControlledSwitches";
import useStore from "../../store/store";
import {Button, Dialog, DialogContent, DialogTitle} from "@mui/material";
import {useState} from "react";
import {Document, Page, pdfjs} from "react-pdf";
import {pink} from "@mui/material/colors";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;


export default function ButtonAppBar() {

    const eng = useStore((state) => state.eng);
    const toggleEng = useStore((state) => state.toggleEng);

    const [readMode, setReadMode] = useState(false);

    const [numPages, setNumPages] = useState(1);
    const [pageNumber, setPageNumber] = useState(1);

    function onDocumentLoadSuccess(numPages) {
        setNumPages(numPages._pdfInfo.numPages);
    }

    return (
        <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static">
                <Toolbar>
                    <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                        {eng ?  `THE STUDY OF MEMBRANE RESTING POTENTIAL AND ACTION` : `ВИЗНАЧЕННЯ ЕЛЕКТРИЧНИХ ХАРАКТЕРИСТИК ПОРОГУ ЗБУДЖЕННЯ ЕЛЕКТРОННОЇ МОДЕЛІ БІОМЕМБРАНИ`}
                    </Typography>
                    <Button sx={{ flexGrow: 1, marginRight: '30px' }} variant="contained" color="secondary"  onClick={() => setReadMode(true)}>{eng ? 'Read theory' : 'Прочитати теорію'}</Button>
                    <ControlledSwitches eng={eng} handleChange={toggleEng}/>
                </Toolbar>
            </AppBar>

                <Dialog open={readMode} fullWidth maxWidth="lg">
                    <DialogTitle>
                        <Box sx={{display: 'flex', justifyContent: 'space-between'}}>
                              <Box>{eng ? 'Theory' : 'Теорія'}</Box>
                        </Box>
                    </DialogTitle>
                    <DialogContent>
                        {eng ?
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Document file="/Theme_16_membrane_potentials.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                                            <Page pageNumber={pageNumber}
                                                  renderTextLayer={false}
                                                  renderAnnotationLayer={false}
                                            />
                                        </Document>
                                        <Box sx={{display: 'flex'}}>
                                            <Button onClick={() => pageNumber === 1 ? null : setPageNumber(pageNumber - 1)}> Prev page </Button>
                                            <Button onClick={() => pageNumber === numPages ? null : setPageNumber(pageNumber + 1)}> Next page </Button>
                                        </Box>
                                    </Box>
                                    :
                                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                        <Document file="/lab_ukr.pdf" onLoadSuccess={onDocumentLoadSuccess}>
                                            <Page pageNumber={pageNumber}
                                                  renderTextLayer={false}
                                                  renderAnnotationLayer={false}
                                            />
                                        </Document>
                                        <Box sx={{display: 'flex'}}>
                                            <Button onClick={() => pageNumber === 1 ? null : setPageNumber(pageNumber - 1)}> Попередня сторінка </Button>
                                            <Button onClick={() => pageNumber === numPages ? null : setPageNumber(pageNumber + 1)}> Наступна сторінка </Button>
                                        </Box>
                                    </Box>
                        }
                    </DialogContent>
                    <DialogContent>
                        <Button onClick={() => setReadMode(false)}>{eng ? 'Close' : 'Закрити'}</Button>
                    </DialogContent>
                </Dialog>

        </Box>
    );
}
